import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="bg-light-bg text-text-light py-20 md:py-28 relative" data-id="element-147">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-148">
        <FadeIn data-id="element-149">
          <p className="text-2xl md:text-3xl font-serif italic leading-relaxed text-center mb-10 text-primary-dark" data-id="element-150">
            "Son las 8 de la noche de un domingo y ese nudo en el estómago ya
            apareció. Sabés que mañana empieza el ciclo otra vez: el jefe que no
            se decide, el compañero que no hace nada o ese ambiente tóxico que
            te drena la energía antes del mediodía."
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-151">
          <div className="w-16 h-1 bg-accent mx-auto mb-10 rounded-full" data-id="element-152"></div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-153">
          <p className="text-lg md:text-xl leading-[1.8] text-text-light/80 mb-6" data-id="element-154">
            Sentís que tu trabajo se está robando tu identidad, tu descanso y tu
            buen humor.
          </p>
          <p className="text-lg md:text-xl leading-[1.8] text-text-light/80 font-medium" data-id="element-155">
            Pero el problema no es tu capacidad, es que te faltan los escudos
            para separar quién sos de lo que hacés para pagar el alquiler.
          </p>
        </FadeIn>
      </div>
    </section>;
}